<template>
  <v-container fluid>
    <v-btn
        fab absolute right x-small color="teal" dark
        @click="refresh"
    >
      <v-icon>refresh</v-icon>
    </v-btn>
    <h2 class="pt-0">CAMARERO</h2>

    <v-divider class="mb-3"></v-divider>
    <v-row no-gutters>
      <v-col cols="12" sm="6" class="pr-1">
        <v-card>
          <v-card-title>{{ $t('delivery.states.WAITING') }}</v-card-title>
          <order-flow-waiter-table ref="READY"
                                   state="READY"
                                   drink-state="WAITING"
                                   mode="SALON"
                                   :action-prev="false"
                                   @orderUpdateNext="$refs.DELIVERED.fetchOrders()"
                                   :show-icons="false"
          />

        </v-card>
      </v-col>
      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title>{{ $t('delivery.states.DELIVERED') }}</v-card-title>
          <order-flow-waiter-table ref="DELIVERED"
                                   state="DELIVERED"
                                   drink-state="SERVED"
                                   mode="SALON"
                                   delivery-user-read-only
                                   @orderUpdatePrev="$refs.READY.fetchOrders()"
                                   :show-icons="false"
                                   :action-next="false"
                                   :disableHeaders="['print']"

          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import OrderFlowWaiterTable from "@/modules/delivery/components-core/business/OrderFlowWaiterTable";


export default {
  name: "OrderFlowWaiterPage",
  components: {OrderFlowWaiterTable},
  data() {
    return {
      interval: null
    }
  },
  mounted() {
    this.$store.dispatch('fetchCategories')
    this.interval = setInterval(() => {
      console.log("Waiter Refreshing...")
      this.refresh()
    }, 10000)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  methods: {
    refresh() {
      this.$refs.READY.fetchOrders()
      this.$refs.DELIVERED.fetchOrders()
    }
  }
}
</script>

<style scoped>

</style>
